import { createContext, useCallback, useMemo, useReducer } from 'react';
import { loggingMiddleware } from '../../utils/store';
import { getExternalOptions, getProperties, validatePropertyBeforeEdit } from './functions';
import { GET_EXTERNAL_OPTIONS, GET_PROPERTIES, initialState, reducer, RESET_PROPERTY_VALIDATION_ERRORS, RESET_VALIDATION_ERRORS, SET_IS_VALIDATING, VALIDATE_PROPERTY } from './reducer';
import { jsx as _jsx } from "react/jsx-runtime";
export const PropertiesContext = /*#__PURE__*/createContext(initialState);

// used in unit tests
export let propertiesDispatch;
export const PropertiesContextProvider = ({
  children,
  apiWrapper
}) => {
  const [properties, dispatchCTX] = useReducer(loggingMiddleware('properties')(reducer), initialState);
  const asyncFuncArg = useMemo(() => ({
    dispatch: dispatchCTX,
    apiWrapper
  }), [apiWrapper]);
  const dispatch = useCallback(action => {
    switch (action.type) {
      case GET_PROPERTIES:
        getProperties(asyncFuncArg, action.payload);
        break;
      case GET_EXTERNAL_OPTIONS:
        getExternalOptions(asyncFuncArg, action.payload);
        break;
      case VALIDATE_PROPERTY:
        validatePropertyBeforeEdit(asyncFuncArg, action.payload);
        break;
      default:
        {
          dispatchCTX(action);
        }
    }
  }, [asyncFuncArg]);
  propertiesDispatch = dispatch;
  const actions = useMemo(() => ({
    resetValidationErrors: () => dispatch({
      type: RESET_VALIDATION_ERRORS
    }),
    resetPropertyValidationErrors: value => dispatch({
      type: RESET_PROPERTY_VALIDATION_ERRORS,
      payload: value
    }),
    setIsValidating: data => dispatch({
      type: SET_IS_VALIDATING,
      payload: data
    }),
    validateProperty: data => dispatch({
      type: VALIDATE_PROPERTY,
      payload: data
    }),
    getExternalOptions: options => dispatch({
      type: GET_EXTERNAL_OPTIONS,
      payload: options
    }),
    getProperties: data => dispatch({
      type: GET_PROPERTIES,
      payload: data
    })
  }),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  const state = useMemo(() => Object.assign({}, properties, {
    dispatch,
    propertiesActions: actions
  }), [properties, dispatch, actions]);
  return /*#__PURE__*/_jsx(PropertiesContext.Provider, {
    value: state,
    children: children
  });
};